module.exports = __webpack_public_path__ + "static/media/Three Weeks to Go.8ee7120c.jpg";